module.exports = __webpack_public_path__ + "img/3.4c542169.png";